<input type="checkbox" id="findMatchDiacritics" class="toolbarField" tabindex="96" />
<label for="findMatchDiacritics" class="toolbarLabel" data-l10n-id="find_match_diacritics_label">Match Diacritics</label>
